import { Component, OnInit, Input } from '@angular/core';
import { EPTabsComponent } from './ep-tabs.component';

@Component({
    selector: 'ep-tab',
    templateUrl: './ep-tab.component.html',
    styleUrls: ['./ep-tab.component.scss']
})
export class EPTabComponent implements OnInit {
    @Input() tabTitle;
    public active: boolean;

    constructor(tabs: EPTabsComponent) {
        tabs.addTab(this);
    }


    ngOnInit() {
    }

}
